module.exports = __webpack_public_path__ + "static/media/services_logo_ocha.b2c9991f.png";